export default __webpack_public_path__ + "static/PosterDemoReelVisualmaMoz-31d60027d2b34e9500350b1371b15857.jpg";